export function roundNicely(value: number) {
  return Math.round(value * 100) / 100;
}
